import Cookies from 'js-cookie';
import { destroyCookies } from '../login/login_logic';
import { NewClassRequest } from '../classes/NewClassRequest';
import { NotificationManager } from 'react-notifications';

export const changeEmail = async (form, verificationCode) => {
  const { userId_02 } = Cookies.get();
  const request = new NewClassRequest(
    `${process.env.REACT_APP_URL_API_LARAVEL}/users/change/email/${userId_02}`,
    'patch',
    null,
    {
      current_email: form.oldEmail,
      new_email: form.newEmail,
      confirmation_email: form.confirmEmail,
      verification_code: verificationCode,
    }
  );

  const res = await request.executeRequest();

  if (res.code === 200 && res.response && !res.response.error && res.response.message !== '') {
    destroyCookies();
    setTimeout(() => NotificationManager.success(res.response.message), 500);
    return { ok: true, res };
  }

  if (res.code === 200 && res.response && res.response.error && res.response.message !== '') {
    NotificationManager.error(res.response.message);
    return { ok: false, res };
  }

  NotificationManager.error(
    'Ha sucedido un error desconocido, inténtalo nuevamente o contacta al administrador'
  );
  return { ok: false, res };
};

export const sendVerificationCode = async (email, oldEmail) => {
  const { userId_02 } = Cookies.get();
  const request = new NewClassRequest(
    `${process.env.REACT_APP_URL_API_LARAVEL}/users/send/verification_code/${userId_02}`,
    'post',
    null,
    {
      current_email: oldEmail,
      new_email: email,
    }
  );
  const res = await request.executeRequest();

  if (res.code === 200 && res.response && !res.response.error && res.response.message !== '') {
    NotificationManager.success(res.response.message);
    return { ok: true, res };
  }

  if (res.code === 200 && res.response && res.response.error && res.response.message !== '') {
    NotificationManager.error(res.response.message);
    return { ok: false, res };
  }

  NotificationManager.error(
    'Ha sucedido un error desconocido, inténtalo nuevamente o contacta al administrador'
  );
  return { ok: false, res };
};
